"use client";
import {
  CompositeContextProvider,
  CompositeScopedContextProvider
} from "./X3ATWMYX.js";
import {
  PopoverContextProvider,
  PopoverScopedContextProvider
} from "./7CRP5UGO.js";
import {
  createStoreContext
} from "./LFJDOMBA.js";

// src/combobox/combobox-context.tsx
import { createContext } from "react";
var ctx = createStoreContext(
  [PopoverContextProvider, CompositeContextProvider],
  [PopoverScopedContextProvider, CompositeScopedContextProvider]
);
var useComboboxContext = ctx.useContext;
var useComboboxScopedContext = ctx.useScopedContext;
var useComboboxProviderContext = ctx.useProviderContext;
var ComboboxContextProvider = ctx.ContextProvider;
var ComboboxScopedContextProvider = ctx.ScopedContextProvider;
var ComboboxItemValueContext = createContext(
  void 0
);

export {
  useComboboxContext,
  useComboboxScopedContext,
  useComboboxProviderContext,
  ComboboxContextProvider,
  ComboboxScopedContextProvider,
  ComboboxItemValueContext
};
